<template>
    <v-flex>
        <v-layout row wrap>
            <v-flex id="file-drag-drop">
                <div>
                    <form
                        ref="fileform"
                        v-on:drag.stop.prevent
                        v-on:dragstart.stop.prevent
                        v-on:dragend.stop.prevent
                        v-on:dragover.stop.prevent
                        v-on:dragenter.stop.prevent
                        v-on:dragleave.stop.prevent
                        v-on:drop.stop.prevent="onDropFileEvent"
                        class="drop-area">
                        <v-layout row wrap>
                            <v-flex
                                xs12
                                md8
                                v-if="files.length > 0">
                                <v-layout row class="drop-area__row">
                                    <v-flex
                                        v-for="(file,key,index) in files"
                                        :key="key"
                                        class="file-icons">

                                        <i large :class='iconClassNames(file.type)' class="icon-field">
                                            <em class="fa fa-minus-circle close-btn" :data-qe-id="`remove_file_${index}`" @click="unSelectFile(key)"></em>
                                        </i>

                                        <span class="file-name" :title="file.name">{{file.name}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex
                                v-if="!isFilesUploading"
                                :class="[files.length > 0 ? sm4 : xs12]"
                                class="file-select-btn">
                                <file-upload
                                    class="card__file-upload"
                                    v-model="addedFiles"
                                    ref="file_upload"
                                    :multiple="multiple"
                                    input-id="`file_upload_Id`"
                                    data-qe-id="`file_upload_Id`">
                                    <v-icon class="far fa-plus-square" large>
                                    </v-icon>
                                </file-upload>
                                <span class="drop-files">{{communityCommonConstant.filesAndMedia.BROWSE}}<br>{{communityCommonConstant.filesAndMedia.DRAG_FILES_HERE}}</span>
                            </v-flex>
                            <v-flex
                                v-else
                                sm12
                                md4
                                class="upload-progress-area">
                                <v-icon class="fas fa-file-video icon-field" large>
                                </v-icon>
                                <progress class="progress" :value.prop="videoUploadPercentage" max="100">
                                </progress>
                                <span v-if="files.length < 6">{{videoUploadPercentage}}%</span>
                                <span v-else>{{communityCommonConstant.filesAndMedia.UPLOADING}} {{files.length}} {{communityCommonConstant.filesAndMedia.FILES}}</span>
                            </v-flex>
                        </v-layout>
                    </form>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm7>
                <span class="error-message">{{errorMessage}}</span>
            </v-flex>
            <v-flex
                xs12
                sm5
                text-xs-right>
                <v-btn
                    id="dialog_cancel_btn"
                    :disabled="isFilesUploading"
                    @click="closeFilesDialog()"
                    data-qe-id="upload_cancel_btn"
                    class="primary_btn small">
                    {{'Cancel'}}
                </v-btn>
                <v-btn
                    id="dialog_add_btn"
                    :disabled="files.length === 0 || isFilesUploading"
                    @click="uploadFilesClick()"
                    data-qe-id="upload_add_file_btn"
                    class="primary_btn small">
                    {{'Add File'}}
                </v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { communityCommonConstant } from "../ChapterPage/communityCommon.constant";
    import FileUpload from "vue-upload-component";
    import { ManageVideosConstants, iconClassNames } from './AssistPageConstants';

    export default {
        name: 'UploadVideos',
        components: {
            FileUpload,
        },
        data() {
            return {
                xs4: 'xs4',
                xs12: 'xs12',
                ManageVideosConstants,
                communityCommonConstant,
                addedFiles: [],
                errorMessage: '',
                files: [],
                isFilesUploading: false,
                multiple: true,
            };
        },
        props: {
            existingFileNames: {
                type: Array,
                required: true,
            },
            fileTypesSupported: {
                type: Array,
                required: true,
            },
        },
        watch: {
            addedFiles(vals) {
                if (vals.length) {
                    vals.forEach((val) => {
                        if (this.validateFileTypes(val.file.name) && this.validateFileNameLength(val.file.name.split('.')[0]) && this.validateDuplicateNames(val.file)) {
                            this.files.push(val.file);
                        }
                    });
                    this.addedFiles = [];
                }
            },
        },
        computed: {
            ...mapGetters("assistPage", [storeGetters.videoUploadPercentage]),
        },
        methods: {
            ...mapActions({
                uploadFiles: `assistPage/${storeAction.uploadFiles}`,
                getTakeTourVideos: `assistPage/${storeAction.getTakeTourVideos}`,
            }),
            iconClassNames,
            onDropFileEvent(e) {
                const selectedFiles = e.dataTransfer.files;
                for (let i = 0; i < selectedFiles.length; i += 1) {
                    if (this.validateFileTypes(selectedFiles[i].name) && this.validateFileNameLength(selectedFiles[i].name.split('.')[0]) && this.validateDuplicateNames(selectedFiles[i])) {
                        this.files.push(selectedFiles[i]);
                    }
                }
            },
            validateFileNameLength(filename) {
                if (filename.length > 30) {
                    this.errorMessage = this.communityCommonConstant.filesAndMedia.FILE_NAME_LENGTH_EXCEEDED;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    return false;
                }
                return true;
            },
            validateFileTypes(filename) {
                if (!(new RegExp(this.fileTypesSupported.join("|")).test(filename))) {
                    this.errorMessage = communityCommonConstant.filesAndMedia.FILE_NOT_SUPPORTED;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    return false;
                }
                return true;
            },
            validateDuplicateNames(file) {
                let isValid = true;
                if (this.files.filter(f => f.name === file.name).length > 0 || this.existingFileNames.filter(name => name === file.name).length > 0) {
                    this.errorMessage = communityCommonConstant.filesAndMedia.FILENAME_ALREADY_EXISTS;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    isValid = false;
                }
                return isValid;
            },
            unSelectFile(key) {
                this.files.splice(key, 1);
            },
            uploadFilesClick() {
                if (this.files.length > 0) {
                    this.isFilesUploading = true;
                    const formData = new FormData();
                    if (this.files && this.files.length) {
                        this.files.forEach((item, index) => {
                            formData.append(`File${index}`, item);
                        });
                    }

                    this.uploadFiles(formData)
                        .then(() => {
                            setTimeout(() =>
                                this.getTakeTourVideos(), 500);
                        })
                        .then(() => {
                            this.isFilesUploading = false;
                            this.files = [];
                            this.closeFilesDialog();
                        })
                        .catch((err) => {
                            this.isFilesUploading = false;
                            this.errorMessage = err.message;
                            setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                        });
                }
            },
            closeFilesDialog() {
                this.$emit('closeDialog');
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";
    $control-height: 100px;
    $marginTop-progress: $control-height - 85px;
    $dragdrop_background: $ypo-extra-light-gray;
    $dragdrop_background_mian: $white;
    $dorder_dash_color: $ypo-light-medium-gray;
    $image_icon_color:$ypo-duskblue;

    #file-drag-drop {
        background-color: $dragdrop_background;

        .drop-area {
            border: 2px dashed $dorder_dash_color;
            border-radius: 4px;
            background-color: $dragdrop_background_mian;
            padding: 20px;
            margin: 10px 25px 30px 25px;
            text-align: center;
            min-height: 125px;

            &__row {
                max-width: 100%;
                overflow-x: auto;
            }

            @include breakpoint(xs) {
                margin: 10px 15px 30px 15px;
                padding: 10px;
                min-height: inherit;
            }
        }

        .file-icons {
            padding: 5px 0;
            margin: 0 15px;
            max-width: 80px;

            i {
                font-size: 40px;
                color: $ypo-cta;
                position: relative;
            }

            em {
                position: absolute;
                top: -5px;
                right: -23px;
                font-size: 18px;
                cursor: pointer;
                color: $ypo-cta;
            }

            span {
                color: $image_icon_color !important;
                margin-top: 5px;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .file-select-btn {
            color: $ypo-cta;
            padding-top: 10px;

            @include breakpoint(xs) {
                padding-top: 0px;
                margin-bottom: 10px;
            }

            .icon-field {
                color: $ypo-cta;
            }

            span {
                color: $ypo-cta;
                display: block;

                i {
                    color: $ypo-cta;
                }

                label {
                    cursor: pointer;
                }
            }
        }

        .upload-progress-area {
            .icon-field {
                margin-left: -5px;
                color: $ypo-cta
            }

            span {
                color: $ypo-cta;
            }
        }

        .progress {
            appearance: none;
            padding: 0;
            border: none;
            border-radius: 0;
            display: block;
            color: $ypo-cta;
            width: 100%;
            height: 5px;
            margin-top: $marginTop-progress;
        }

        /* Chrome */
        progress::-webkit-progress-bar {
            background-color: $ypo-light-gray;
        }

        progress::-moz-progress-bar {
            background-color: $ypo-light-gray;
        }

        progress::-webkit-progress-value {
            background-color: $ypo-cta;
        }
    }

    .error-message {
        color: red;
        margin: 8px;
    }
</style>
